import React, { Fragment } from "react";
import { Breadcrumbs, Paper, Grid, TextField, Typography, makeStyles, Box, Button, CircularProgress } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Link } from "react-router-dom";

function Page(props) {
	const {
		usuarios_responsables,
		handle_salir,
		formik,
	} = props;

	const classes = useStyle();
	const { values, handleChange, setFieldValue, submitForm, handleSubmit, isSubmitting, errors, touched } = formik;

	if (!usuarios_responsables) {
		//Si aún no cargan los datos.
		return (
			<Box display="flex" justifyContent="center" alignItems="center" height="100%">
				<CircularProgress />
			</Box>
		);
	}

	return (
		<Fragment>
			<Breadcrumbs separator=">">
				<Typography color="textPrimary">Módulo Responsables</Typography>
				<Link to="/responsables">Responsables</Link>
				<Typography color="textPrimary">{`Modificar Responsable ${values.persona ? values.persona.nombre : null}`}</Typography>
			</Breadcrumbs>
			<Paper className={classes.card}>
				<form onSubmit={handleSubmit}>
					{/* CAMPOS DEL RESPONSABLE */}
					<Grid container spacing={3}>
						<Grid item xs={6} xl={4}>
							{/* USUARIO RESPONSABLE */}
							<Autocomplete
								name="persona"
								value={Array.from(usuarios_responsables).find(ur => ur.usuario_id === values.persona.usuario_id)}
								options={usuarios_responsables}
								onChange={(event, value) => setFieldValue("persona", value ? value : null)}
								getOptionLabel={usuario_responsable => usuario_responsable.nombre_completo}
								disableClearable={true}
								disabled
								renderInput={(params) => (
									<TextField
										label="Usuario"
										variant="outlined"
										required
										error={touched.persona && errors.persona && Boolean(errors.persona)}
										helperText={touched.persona && errors.persona ? errors.persona : ""}
										{...params}
									/>
								)}
							/>
						</Grid>
						<Grid item xs={6} xl={4}>
							{/* CORRELATIVO */}
							<TextField
								name="correlativo"
								label="Correlativo"
								value={values.correlativo}
								variant="outlined"
								fullWidth
								required
								onChange={handleChange}
								error={touched.correlativo && errors.correlativo && Boolean(errors.correlativo)}
								helperText={touched.correlativo && errors.correlativo ? errors.correlativo : ""}
							/>
						</Grid>
					</Grid>
					<Box display="flex" flexDirection="row-reverse">
						<Button onClick={handle_salir} variant="outlined" color="primary" className={classes.button}>Salir</Button>
						<Button onClick={submitForm} variant="contained" color="primary" className={classes.button}>Actualizar</Button>
					</Box>
				</form>
			</Paper>
		</Fragment>
	);
}

const useStyle = makeStyles((theme) => ({
	card: {
		padding: theme.spacing(3),
	},
	button: {
		margin: theme.spacing(1),
	}
}));

export default Page;